import { Component, Input } from '@angular/core';

import { ContextType, Size, StringTMap } from '@bn/primitives';

@Component({
  selector: 'bn-web-ui-progress-circle',
  templateUrl: './progress-circle.component.html',
  styleUrls: ['./progress-circle.component.scss'],
})
export class ProgressCircleComponent {
  @Input()
  public contextType?: ContextType = 'success';

  @Input()
  public size?: Extract<Size, 'sm' | 'md'> = 'sm';

  @Input()
  public progress = 75;

  @Input()
  public transitionDuration = '150ms';

  public get progressProps(): StringTMap<string | number> {
    if (this.progress < 0 || this.progress > 100) {
      this.progress = 0;
    }

    const deg = this.progress * 3.6;
    let fillOpacity = undefined;
    let maskOpacity = undefined;
    let transform = undefined;

    if (this.progress > 50) {
      fillOpacity = 1;
      maskOpacity = 0;
    } else {
      fillOpacity = 0;
      maskOpacity = 1;
    }

    transform = `rotate(${deg}deg)`;

    return {
      maskOpacity,
      fillOpacity,
      transform,
    };
  }
}
